import {Injectable, Injector} from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import {Observable, tap} from 'rxjs';
import {AuthService} from 'app/core/auth/auth.service';
import {Router} from "@angular/router";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    /**
     * Constructor
     */
    constructor(private _authService: AuthService,
                private _injector: Injector,
                private _router: Router) {
    }

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(req).pipe(
            tap(
                event => this.handleResponse(req, event),
                error => this.handleError(req, error)
            ));
    }

    handleResponse(req: HttpRequest<any>, event) {}

    handleError(req: HttpRequest<any>, event) {

        const fp = "forgot-password";
        // Exclude interceptor for forgot-password:
        if (req.url.search(fp) === -1) {
            return;
        }

        const si = "sign-in";
        // Exclude interceptor for sign-in:
        if (req.url.search(si) === -1) {
            return;
        }

        if (event.status === 500) {
            this._router.navigate(['/500-internal-server-error']);
        }
        if (event.status === 422) {
            this._router.navigate(['/500-internal-server-error']);
        }
        if (event.status === 404) {
            this._router.navigate(['/404-not-found']);
        }
        if (event.status === 503) {
            this._router.navigate(['/maintenance']);
        }


    }
}
